export const orderItemHanding = [
    { label: "Left", value: 'L' },
    { label: "Right", value: 'R' },
    { label: "None", value: null }
] as const;